module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou2-55d7f675559fb9c10a566539972d83fa.jpg";